import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const RootLayout = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route changes
    if (window.gtag) {
      window.gtag('config', window.gaId || '', {
        page_path: location.pathname + location.search,
        send_page_view: true
      });
    }
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-purple-900 via-pink-900 to-blue-900 animate-gradient-xy">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-500/10 via-pink-500/10 to-blue-500/10 pointer-events-none" />
      <div className="fixed inset-0 bg-black/40 pointer-events-none" />
      
      <Navbar />
      
      <main className="flex-grow relative">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default RootLayout;